import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaWhatsapp, FaBars, FaTimes } from 'react-icons/fa';

interface NavbarProps {
  isScrolled: boolean;
}

const Navbar = ({ isScrolled }: NavbarProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5562982615656', '_blank');
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${
      isScrolled ? 'py-4 bg-white shadow-md' : 'py-6 bg-transparent'
    }`}>
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="#" className="text-2xl font-bold text-[#4A3B36]">
            Kesia Almeida
          </a>

          {/* Links de navegação - Desktop */}
          <div className="hidden md:flex items-center gap-8">
            <a href="#sobre" className="text-[#6B5C57] hover:text-[#4A3B36] transition-colors">
              Sobre
            </a>
            <a href="#servicos" className="text-[#6B5C57] hover:text-[#4A3B36] transition-colors">
              Serviços
            </a>
            <a href="#contato" className="text-[#6B5C57] hover:text-[#4A3B36] transition-colors">
              Contato
            </a>
            <button
              onClick={handleWhatsAppClick}
              className="group bg-[#4A3B36] hover:bg-[#6B5C57] text-white px-6 py-2.5 rounded-xl 
                       font-medium transition-all duration-300 flex items-center gap-2 relative overflow-hidden"
            >
              <div className="absolute inset-0 bg-[#D4B4A8] transform scale-x-0 group-hover:scale-x-100 
                           transition-transform duration-300 origin-left opacity-20" />
              <FaWhatsapp className="text-lg relative z-10" />
              <span className="relative z-10">Agendar</span>
            </button>
          </div>

          {/* Botão do menu - Mobile */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-[#4A3B36] p-2 hover:bg-[#F8F3F0] rounded-lg transition-colors"
          >
            {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </div>
      </div>

      {/* Menu mobile */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white border-t border-[#E8D5CB] mt-4"
          >
            <div className="max-w-[1200px] mx-auto px-4 py-6 flex flex-col gap-4">
              <a
                href="#sobre"
                className="text-[#6B5C57] hover:text-[#4A3B36] transition-colors py-2"
                onClick={() => setIsOpen(false)}
              >
                Sobre
              </a>
              <a
                href="#servicos"
                className="text-[#6B5C57] hover:text-[#4A3B36] transition-colors py-2"
                onClick={() => setIsOpen(false)}
              >
                Serviços
              </a>
              <a
                href="#contato"
                className="text-[#6B5C57] hover:text-[#4A3B36] transition-colors py-2"
                onClick={() => setIsOpen(false)}
              >
                Contato
              </a>
              <button
                onClick={() => {
                  handleWhatsAppClick();
                  setIsOpen(false);
                }}
                className="group bg-[#4A3B36] hover:bg-[#6B5C57] text-white px-6 py-3 rounded-xl 
                         font-medium transition-all duration-300 flex items-center justify-center gap-2 
                         relative overflow-hidden w-full"
              >
                <div className="absolute inset-0 bg-[#D4B4A8] transform scale-x-0 group-hover:scale-x-100 
                             transition-transform duration-300 origin-left opacity-20" />
                <FaWhatsapp className="text-lg relative z-10" />
                <span className="relative z-10">Agendar Consulta</span>
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
